export { FastMovementType } from './fastMovementsDetection';
export * from './useFastMovementsDetection';
